<template>
  <ListView
    modelName="PurchaseDeliveryItem"
    perm="purchase.menu_purchase_delivery_item"   
    svg="icon_side_arrival_list"
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_purchase_delivery_item"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="PurchaseDeliveryItem"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    class="purchase_delivery_item"
    borderColor="#4099DA"
    backColor="#E5F4FF"    
    tourId="291644"
    :comparer="(a,b)=>a.id == b.id"        
    :popup="popup"    
    :checkStateObject="(a)=>a.delivery"
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.virtualState" list="purchaseDeliveryItemStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.deliveryItemNo }}</GridItem>
    <!-- <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.seqNo }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[1]" slot-scope="{ item }">{{ item.id }}</GridItem> -->
    <GridItem :slot="listSlots[2]" slot-scope="{ item }">{{ item.delivery.bookDate| date }}</GridItem>    
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.delivery?item.delivery.counterpart.name:'' }}</GridItem>

    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>
    <GridItem :slot="listSlots[7]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.deliveryFlag | deliveryFlags }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.warehouse?item.warehouse.name:'' }}</GridItem>
    <!-- <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.receiverId | counterpart }}</GridItem> -->
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.deliveryNo }}</GridItem>
    <!-- <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.delivery.scheduleDeliveryDate | date}}</GridItem> -->
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.delivery.deliveryDate | date}}</GridItem>    
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.delivery.currencyCode | currency }}</GridItem>        
    <GridItem :slot="listSlots[13]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.orderItem ? item.orderItem.orderItemNo : "" }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:''}}</GridItem> 
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.segmentId | segment }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ ( item.delivery ? item.delivery.pic  : 0 ) | userGroup }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.commodityName }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }" :right="true">{{ item.adjustmentQuantity | numeric(item.commodity.quantityScale)  }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.isNCV | isTarget }}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.commodity.isNoStock | isNoStock }}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.delivery.currencyCode) }}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }" :right="true">{{ item.amountFC | amountFC(item.delivery.currencyCode)}}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }" :right="true">{{ item.amount | amount }}</GridItem>
    <!-- <GridItem :slot="listSlots[24]" slot-scope="{ item }">{{ item.description }}</GridItem> -->
    <GridItem :slot="listSlots[26]" slot-scope="{ item }">{{ item.orderItem ? item.orderItem.order.refNo : "" }}</GridItem>
    <GridItem :slot="listSlots[27]" slot-scope="{ item }">{{ item.delivery ? item.delivery.refNo : "" }}</GridItem>
    <!-- <GridItem :slot="listSlots[26]" slot-scope="{ item }">{{ item.orderItem ? item.orderItem.salesRefNo : "" }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[27]" slot-scope="{ item }">{{ item.customerOrderNo }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[29]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow"/></GridItem> -->
    <GridItem :slot="listSlots[28]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[29]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[30]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[31]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>

    <!-- 予備項目 -->
    <GridItem :slot="listSlots[32]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ? item.commodity.reserveText1 : item.reserveText1)}}</GridItem>
    <GridItem :slot="listSlots[33]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ? item.commodity.reserveText2 : item.reserveText2)}}</GridItem>
    <GridItem :slot="listSlots[34]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ? item.commodity.reserveText3 : item.reserveText3)}}</GridItem>
    <GridItem :slot="listSlots[35]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ? item.commodity.reserveText4 : item.reserveText4)}}</GridItem>
    <GridItem :slot="listSlots[36]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ? item.commodity.reserveText5 : item.reserveText5)}}</GridItem>
    <GridItem :slot="listSlots[37]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ? item.commodity.reserveText6 : item.reserveText6)}}</GridItem>
    <GridItem :slot="listSlots[38]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ? item.commodity.reserveMemo1 : item.reserveMemo1)}}</GridItem>
    <GridItem :slot="listSlots[39]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ? item.commodity.reserveMemo2 : item.reserveMemo2)}}</GridItem>
    <GridItem :slot="listSlots[40]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ? item.commodity.reserveMemo3 : item.reserveMemo3)}}</GridItem>
    <GridItem :slot="listSlots[41]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ? item.commodity.reserveDate1 : item.reserveDate1) | date}}</GridItem>
    <GridItem :slot="listSlots[42]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ? item.commodity.reserveDate2 : item.reserveDate2) | date}}</GridItem>
    <GridItem :slot="listSlots[43]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ? item.commodity.reserveDate3 : item.reserveDate3)| date}}</GridItem>
    <GridItem :slot="listSlots[44]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ? item.commodity.reserveList1 : item.reserveList1 ) | category_41}}</GridItem>
    <GridItem :slot="listSlots[45]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ? item.commodity.reserveList2 : item.reserveList2 ) | category_42}}</GridItem>
    <GridItem :slot="listSlots[46]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ? item.commodity.reserveList3 : item.reserveList3 ) | category_43}}</GridItem> 
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :add="false" :copy="false" >
        <ListViewMenu title="返品処理" @click="showReturnDeliveryDialog" tooltip="入荷した商品の返品処理を行います。処理を実行するとマイナスの値の入荷データが作成されます。"/>
        <ListViewMenu v-if="$api.useStockFunction" title="諸掛按分処理" @click="showChargeAllocationDialog" tooltip="選択した入荷明細に対して諸掛の按分登録を行います。" />        
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView" :tabs="searchTabs" :favoriteVisible="!popup">
        <FilterBox title="入荷番号" :value.sync="params.deliveryNo" @click="handler" />
        <FilterBox title="入荷明細番号" :value.sync="params.deliveryItemNo" @click="handler" />
        <FilterBox title="発注番号" :value.sync="params.orderNo" @click="handler" />
        <FilterBox title="発注明細番号" :value.sync="params.orderItemNo" @click="handler" />
        <FilterBox title="発注管理番号" :value.sync="params.refNo" @click="handler" />
        <FilterBox title="入荷管理番号" :value.sync="params.deliveryRefNo" @click="handler" />
        <FilterBox title="顧客注文番号" :value.sync="params.customerOrderNo" @click="handler" />
        <FilterBox title="商品名称" :value.sync="params.commodityName" @click="handler" />
        <FilterBox title="備考" :value.sync="params.description" @click="handler" />
        <AtcCounterpart title="仕入先" :value.sync="params.counterpart" :needsSupplier="true" @changed="handler" />
        <AtcCounterpart title="倉庫" :value.sync="params.warehouse" :needsWarehouse="true" @changed="handler" />
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />        
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />        
        <AutoComplete title="取引通貨"  :value.sync="params.currencyCode" list="currency" @changed="handler" v-if="hasLicenseCurrency" />                 
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />         
        <Calendar title="仕入日(From)" :value.sync="params.bookDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="仕入日(To)" :value.sync="params.bookDateTo" :deletable="true" @changed="handler" />   
        <Calendar title="入荷日(From)" :value.sync="params.deliveryDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="入荷日(To)" :value.sync="params.deliveryDateTo" :deletable="true" @changed="handler" />                    
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />                      
        <ComboBox title="状態" :value.sync="params.state" list="purchaseDeliveryItemStatus" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <FilterBox slot="tab1" title="reserve_text1" :value.sync="params.reserveText1" @click="handler"   v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText1)" />
        <FilterBox slot="tab1" title="reserve_text2" :value.sync="params.reserveText2" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText2)"/>
        <FilterBox slot="tab1" title="reserve_text3" :value.sync="params.reserveText3" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText3)"/>
        <FilterBox slot="tab1" title="reserve_text4" :value.sync="params.reserveText4" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText4)"/>
        <FilterBox slot="tab1" title="reserve_text5" :value.sync="params.reserveText5" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText5)"/>
        <FilterBox slot="tab1" title="reserve_text6" :value.sync="params.reserveText6" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText6)"/>
        <FilterBox slot="tab1" title="reserve_memo1" :value.sync="params.reserveMemo1" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo1)"/>
        <FilterBox slot="tab1" title="reserve_memo2" :value.sync="params.reserveMemo2" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo2)"/>
        <FilterBox slot="tab1" title="reserve_memo3" :value.sync="params.reserveMemo3" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo3)"/>
        <Calendar slot="tab1" title="reserve_date1|(From)" :value.sync="params.reserveDate1From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date1|(To)" :value.sync="params.reserveDate1To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date2|(From)" :value.sync="params.reserveDate2From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date2|(To)" :value.sync="params.reserveDate2To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date3|(From)" :value.sync="params.reserveDate3From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <Calendar slot="tab1" title="reserve_date3|(To)" :value.sync="params.reserveDate3To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <ComboBox slot="tab1" title="reserve_list1" :value.sync="params.reserveList1" list="category_41" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList1)"/>
        <ComboBox slot="tab1" title="reserve_list2" :value.sync="params.reserveList2" list="category_42" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList2)"/>
        <ComboBox slot="tab1" title="reserve_list3" :value.sync="params.reserveList3" list="category_43" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList3)"/>                

      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','その他情報','仕入諸掛按分明細','納入先詳細','予備項目','更新履歴']" :tabVisibles="tabVisibles" :tabTooltips="[null,null,'選択した【入荷明細】に紐づいている【仕入諸掛按分明細】を確認できます。','【納入先】の情報が表示されます。【入荷明細一覧】からは変更できません。','商品単位で任意にテキスト入力・区分の設定・日付設定を行えます｡項目名は【テナント設定】＞【商品予備項目】から変更が可能です。',null]">
        <!-- エディタ編集・機能ボタン -->
        <template slot="menu" slot-scope="{ item}">
          <SplitButton class="button" @click="showDirectAccessDialg(item)" caption="関連伝票"  icon="account_tree" tooltip="関連する伝票へのリンクを表示します。">             
          <!-- <Button class="button" @click="showPurchaseDelivery" caption="伝票表示" :disabled="editor.isEdit" icon="arrow_upward"/> -->
          <Button class="button" @click="showSalesDeliveryItem" caption="出荷明細表示" :disabled="disabledShowSalesDeliveryItemButton(item)" icon="arrow_forward" tooltip="選択した【入荷明細】に紐づく【出荷明細】を表示します。入荷明細の【納入区分】が直送の場合のみ表示可能です。"/>
          </SplitButton>
        </template>
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <!-- <TextBox title="明細ID" :value="item.id" :editor="editor" :enabled="false" /> -->
              <RowSequence title="明細番号" :value="item.seqNo" :displayValue="item.deliveryItemNo"  :perm="$refs.mainList.perm+'.edit'"    :item="item" :editor="editor" :enabled="isEditable(item, false, true, false)" tooltip="【入荷番号】に紐づく明細番号が初回保存時に自動で付与されます。"  buttonTooltip="1件の入荷に複数の入荷明細が登録されている場合､明細の順番を変更する事ができます。明細の数が１つしかない場合は変更できません。"/>
              <!-- <TextBox title="明細番号" :value="item.deliveryItemNo" :editor="editor" :enabled="false" /> -->
              <Calendar title="仕入日" :value="item.delivery.bookDate" :editor="editor" :enabled="false" tooltip="商品が入荷した日付ではなく買掛金が発生する日付です。"/>  
              <!-- <TextBox title="仕入先" :value="item.counterpartId | counterpart" :editor="editor"  :enabled="false" />        -->
              <AtcCounterpart title="仕入先" :value.sync="item.delivery.counterpart" :editor="editor" :needsSupplier="true" :enabled="false" tooltip="【入荷一覧】で登録した【仕入先】が表示されます。【入荷明細一覧】からは変更できません。"/>

              <AtcCommodity title="商品" :value.sync="item.commodity" :editor="editor" :required="true" :enabled="isEditable(item, true, false, true)" @update:value="onChangeCommodity(item)" tooltip="【入荷一覧】から登録を行った、または発注を元に処理を行った商品が表示されます。"/>
              <AtcSKU title="SKU" :value.sync="item.sku" :editor="editor" :commodity="item.commodity" :enabled="isEditable(item, true, false, true)" tooltip="【商品】に対応した【SKU】を選択できます。【SKU一覧】より商品にSKUを設定している場合に、選択が可能です。"/>              
              <AtcConversion title="単位" :value.sync="item.uom2" :editor="editor" :required="true" :enabled="isEditable(item, true, false, true)" :commodity="item.commodity" tooltip="【商品】に対応した単位が表示されます。【商品一覧】に登録されている【計上単位】､または【荷姿一覧】に登録した単位が表示されます。"/>              
              <NumericBox title="入荷数量" :value.sync="item.quantity" :editor="editor" :required="true" :enabled="isEditable(item, false, false,true)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="-99999999.999" max="99999999.999" />            
              <TextBox title="納入区分" :value="item.deliveryFlag | deliveryFlags" :editor="editor" :enabled="false" tooltip="入荷した商品を【在庫】とするか、お客様に【直送】するかの区分が表示されます。【入荷明細一覧】からは変更できません。"/>
              <AtcCounterpart title="入庫倉庫" :value.sync="item.warehouse" :editor="editor" :needsWarehouse="true" :enabled="false"   v-if="item.deliveryFlag == DeliveryFlags.Stock" :key="1" tooltip="商品を保管する倉庫が表示されます。【入荷明細一覧】の【編集】ボタンからは変更できません。"/>
              <!-- <AtcCounterpart title="納入先" :value.sync="item.receiver" :editor="editor" :needsReceiver="true" :enabled="false"   v-if="item.deliveryFlag == DeliveryFlags.Direct" :key="2"/> -->
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <TextBox title="入荷番号" :value="item.deliveryNo" :editor="editor" :enabled="false" linkFormat="/purchase/PurchaseDelivery?deliveryNo={0}" tooltip="選択した【入荷明細】に紐づく入荷伝票番号が表示されます。クリックすると、【入荷一覧】を確認することができます。"/>              
              <!-- <Calendar title="入荷予定日" :value.sync="item.delivery.scheduleDeliveryDate" :editor="editor" :required="true" :enabled="false" />                                                -->
              <Calendar title="入荷日" :value="item.delivery.deliveryDate" :editor="editor" :enabled="false" tooltip="入荷一覧の【入荷日】が表示されます。【入荷明細一覧】からは変更できません。"/>  
              <TextBox title="取引通貨" :value="(item.orderItem ? item.orderItem.order.currencyCode : item.delivery.currencyCode) | currency"  :enabled="false" v-if="hasLicenseCurrency" />                         
              <div style="display:flex">
                <NumericBox title="単価" :value.sync="item.unitPrice" :editor="editor" :required="false" :enabled="isPriceEditable(item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="-999999999.999999" max="999999999.999999" />
                <Button class="button cx_itembutton" style="margin-left:10px"  @click="getPriceAndTaxCode(item)" caption="単価取得" :disabled="!editor.isEdit || !isPriceEditable(item)" tooltip="【商品】の単価を取得します。単価の取得基準は【商品一覧】の【販売単価区分】で登録をします。"/>
              </div>
              <AtcTaxCode title="税区分" :value.sync="item.taxCode" :editor="editor" list="taxCode" :required="true" :enabled="isPriceEditable(item)" tooltip="登録する税区分を選択します。【税区分一覧】のデータを選択できます。"/>
              <TextBox title="発注明細番号" :value="item.orderItem ? item.orderItem.orderItemNo : ''" :editor="editor" :enabled="false" linkFormat="/purchase/PurchaseOrderItem?orderItemNo={0}" tooltip="【発注明細一覧】から【入荷処理】を行った場合には、対応する【発注明細番号】が表示されます。"/>              
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="入荷データを最後に更新した日時が表示されています。"/>              
              <TextBox title="状態" :value="$api.perms.getStateLabel(item,'purchaseDeliveryItemStatus',true)" :enabled="false" tooltip="入荷データの現在の状態が表示されており､確定や業務処理を行う事で変化します。"/>                    
            </template>
          </EditPanel>
        </template>
        <!-- その他情報タブ -->
        <template slot="tab1" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- その他情報タブ 左側 -->
            <template slot="left">  
              <AtcSegment title="部門" :value.sync="item.segment" :editor="editor" :required="true"  :enabled="false" tooltip="入荷一覧で登録した【部門】が表示されています。【入荷明細一覧】からは変更できません。"/>
              <AutoComplete title="担当者" :value.sync="item.pic"  list="user"  :enabled="false" tooltip="入荷一覧で登録した【担当者】が表示されています。【入荷明細一覧】からは変更できません。"/>               
              <TextBox title="商品名称" :value.sync="item.commodityName" :editor="editor" :required="true" :enabled="isEditable(item, true, false, true)" length="100" tooltip="【商品】に登録した商品の商品名称に登録した値が表示されます。【納入区分】が直送の場合この画面で変更する事はできません。"/>
              <NumericBox title="調整数量" :value.sync="item.adjustmentQuantity" :editor="editor" :enabled="isEditable(item, false, true, false)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="-99999999.999" max="99999999.999" tooltip="金額の計上はせずに入荷数量を調整したい場合に数量を入力します。"/>
              <!-- <ComboBox title="NCV" :value.sync="item.isNCV" :editor="editor" list="isTarget" :enabled="isEditable(item, true, false)" /> -->
              <CheckBox title="NCV" :value.sync="item.isNCV" :editor="editor" list="isTarget" :enabled="isEditable(item, true, false, true)" v-if="hasLicenseCurrency"/>
              <TextBox title="棚卸対象外" :value="(item.commodity != null ? item.commodity.isNoStock : false) | isNoStock" :editor="editor" :enabled="false" tooltip="【商品】に登録した商品の【棚卸商品区分】の値が表示されます。"/>
              <TextBox title="取引金額" :value="$api.formatter.formatAmountFC(item.dealAmountFC,item.delivery.currencyCode)"  :enabled="false"  :nullValue="0" tooltip="取引金額が表示されます。【入荷数量×単価】の計算方法で出力されています。"/>
              <TextBox title="税抜金額" :value="$api.formatter.formatAmountFC(item.amountFC,item.delivery.currencyCode)" :enabled="false"  :nullValue="0" tooltip="税抜金額が表示されます。取引金額と税区分、税率(%)で計算されています。"/>
              <TextBox title="計上金額" :value="$api.formatter.formatAmount(item.amount)" :enabled="false"  :nullValue="0"  v-if="hasLicenseCurrency"/>
            </template>
            <!-- その他情報タブ 右側 -->
            <template slot="right">               
              <TextBox title="発注管理番号" :value="item.orderItem ? item.orderItem.order.refNo : ''" :enabled="false" tooltip="発注時に【発注管理番号】を設定した場合に表示されます。"/>
              <TextBox title="入荷管理番号" :value="item.delivery ? item.delivery.refNo : ''" :enabled="false" tooltip="入荷時に【入荷管理番号】を設定した場合に表示されます。"/>
              <TextBox title="顧客注文番号" :value="item.orderItem ? item.orderItem.salesCustomerOrderNo : ''" :enabled="false" tooltip="受注時に【顧客注文番号】を設定した場合に表示されます。"/>
              <TextBox title="備考" :value.sync="item.description" :editor="editor" :enabled="isEditable(item, false, true, false)" length="200" rows="8" tooltip="任意で入荷明細に関する情報を最大200文字まで入力できます。"/>
            </template>
          </EditPanel>
        </template>        
        <!-- 仕入諸掛按分明細タブ -->
        <template slot="tab2" slot-scope="{ item}">
          <GrdVoucherItem :voucherNo="item.id" :voucherType="voucherTypes.PurchaseDeliveryItem" :voucherItemType="voucherTypes.PurchaseChargeItem" />
        </template> 
        <!-- 納入先詳細タブ -->
        <template slot="tab3" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 納入先詳細タブ 左側 -->
            <template slot="left">
              <TextBox title="納入先名称" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverName : item.delivery ? item.delivery.outputReceiverName : ''" :enabled="false" length="50" />
              <TextBox title="担当部署名" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverPICSection : item.delivery ? item.delivery.outputReceiverPICSection : ''" :enabled="false" length="50" />
              <TextBox title="担当者" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverPIC : item.delivery ? item.delivery.outputReceiverPIC : ''" :enabled="false" length="30" />
              <TextBox title="敬称" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverPICHonorificTitle : item.delivery ? item.delivery.outputReceiverPICHonorificTitle : ''" :enabled="false" length="5" />
              <TextBox title="電話番号" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverTelNo : item.delivery ? item.delivery.outputReceiverTelNo : ''" :enabled="false" length="20" />
              <TextBox title="FAX番号" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverFaxNo : item.delivery ? item.delivery.outputReceiverFaxNo : ''" :enabled="false" length="20" />
            </template>
            <!-- 納入先詳細タブ 右側 -->
            <template slot="right">
              <TextBox title="郵便番号" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverPostalCode : item.delivery ? item.delivery.outputReceiverPostalCode : ''" :enabled="false" length="50" />
              <TextBox title="住所1" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverAddress1 : item.delivery ? item.delivery.outputReceiverAddress1 : ''" :enabled="false" length="50" />
              <TextBox title="住所2" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverAddress2 : item.delivery ? item.delivery.outputReceiverAddress2 : ''" :enabled="false" length="50" />
              <TextBox title="住所3" :editor="editor" :value="item.orderItem ? item.orderItem.order.outputReceiverAddress3 : item.delivery ? item.delivery.outputReceiverAddress3 : ''" :enabled="false" length="50" />
            </template>
          </EditPanel>
        </template>                    
        <!-- 予備項目タブ -->
        <template slot="tab4" slot-scope="{ item, editor }">
          <PnlReserveItems :item="item" :editor="editor" :enabled="isEditable(item, false,true, false)" :commodityAttribute="visibleTypes.Editable" :stockAttribute="visibleTypes.Editable"  :orderMemo="visibleTypes.ReadOnly" :deliveryMemo="visibleTypes.Editable" :inheritCommodityAttributeInvalid="true" :commodity="item.commodity" /> 
        </template>

        <!-- 更新履歴タブ -->
        <template slot="tab5" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
    <template slot="modal" slot-scope="{ listView }">        
      <!-- 返品処理ダイアログ -->
      <!-- <ListDialog ref="returnDeliveryDialog" title="返品処理" :buttonNames="rdButtonNames" modelName="PurchaseDeliveryItem" :captions="rdCaptions" :widths="rdWidths" :showAdd="false" :showRemove="false" :execWithIndex="submitReturnDelivery" :height="235" :width="1000" >
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
            <template slot="left">
              <ComboBox title="ワークフロー(入荷)" :value.sync="rdWorkflowId" :editor="editor" :required="true" :enabled="$api.perms.hasWorkflow('purchaseDelivery')" list="workflow_purchaseDelivery" :nullValue="0" @changed="onReturnDeliveryChangeWorkflow()" tooltip="入荷時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【入荷管理】になっているデータから選択ができます。"/>    
              <ComboBox title="ワークフロー(仕入)" :value.sync="rdInvoiceWorkflowId" :editor="editor" :required="true"  :enabled="$api.perms.hasWorkflow('purchaseInvoice')" list="workflow_purchaseInvoice"  :nullValue="0" tooltip="仕入計上時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【仕入計上】になっているデータから選択ができます。"/>                           
            <AutoComplete title="担当者" :value.sync="rdPic" :editor="editor" :required="true" list="user" tooltip="案件の担当者を選択します。【ユーザー】に登録されたデータを選択することができます。"/>
            <Calendar title="返品日" :value.sync="rdReturnDate" :editor="editor" />
            </template>
          </EditPanel>               
        </template>
        <AtcCommodity :slot="rdSlots[0]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.commodity" :enabled="false" />
        <AtcSKU :slot="rdSlots[1]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.sku" :commodity="item.commodity" :enabled="false" />
        <NumericBox :slot="rdSlots[2]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.quantity" :required="true" more="0" max="99999999.999" :decimals="item.commodity.quantityScale" />
        <NumericBox :slot="rdSlots[3]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.adjustmentQuantity" min="0" max="99999999.999" :decimals="item.commodity.quantityScale" :nullValue="0" />        

        <TextBox :slot="rdSlots[4]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[4]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[5]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[5]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[6]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[6]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[7]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[7]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[8]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[8]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :enabled="false" />
        <AutoComplete :slot="rdSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="rdSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="false" />
        <AutoComplete :slot="rdSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="rdSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="false" />
        <AutoComplete :slot="rdSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="rdSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="false" />
      </ListDialog> -->

      <!--諸掛按分処理ダイアログ -->
      <ListDialog ref="chargeAllocationDialog" title="諸掛按分処理" :buttonNames="caButtonNames" modelName="PurchaseCharge" :captions="caConfig.gridCaptions" :widths="caConfig.gridWidths"  :execWithIndex="submitChargeAllocation" :height="235" :width="1000">
        <!-- 諸掛按分処理ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
            <template slot="left">
              <ComboBox title="ワークフロー" :value.sync="caWorkflowId" :editor="editor"  list="workflow_charge"  :required="$api.perms.hasWorkflow('charge')" :enabled="$api.perms.hasWorkflow('charge')" :nullValue="0" @changed="onChargeAllocationChangeWorkflow()" 
                tooltip="諸掛按分時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【諸掛管理】になっているデータから選択ができます。"/>           
              <AutoComplete title="担当者" :value.sync="caPic" :editor="editor" :required="true" list="user" tooltip="案件の担当者を選択します。【ユーザー】に登録されたデータを選択することができます。"/>
              <Calendar title="発生日" :value.sync="caBookDate" :editor="editor" @update:value="onChangeChargeDate" tooltip="仕入諸掛が発生した日付を入力します。初期値は登録日当日になっています。"/>
              <ComboBox title="按分方法" :value.sync="caProportionalDivision" :editor="editor" :list="hasLicenseCurrency?'proportionalDivisionFlags2':'proportionalDivisionFlags2NoLicenseCurrency'" :required="true" tooltip="諸掛の按分方法を選択します。初期値は数量按分になっています。"/>              
              <AutoComplete title="取引通貨" :value.sync="caCurrencyCode" :editor="editor" list="currency" v-if="hasLicenseCurrency" @update:value="onChangeCurrency" :required="true"/>
              <NumericBox title="計上レート" :value.sync="caExchangeRate" v-if="hasLicenseCurrency" :editor="editor" :required="true"/>            
              <TextBox title="諸掛管理番号" :value.sync="caRefNo" :editor="editor" length="30" tooltip="任意で最大30文字まで諸掛に管理番号を登録することができます。"/>   
            </template>
          </EditPanel>               
        </template>
        <!-- 諸掛按分処理ダイアログ 一覧項目 -->
        <AtcCounterpart :slot="caConfig.gridSlots[0]" slot-scope="{ item, editor }" :value.sync="item.counterpart" :editor="editor" :needsSupplier="true" :needsWarehouse="true" :required="true" @update:value="onChangeCounterpart(item)" />
        <AutoComplete  :slot="caConfig.gridSlots[1]" slot-scope="{ item, editor }" :value.sync="item.account" :editor="editor" query="PurchaseChargeAccountMasterQuery" :required="true" />
        <NumericBox  :slot="caConfig.gridSlots[2]" slot-scope="{ item, editor }" :value.sync="item.dealAmountFC" :editor="editor" :required="true" :decimals="caDecimal" />
        <AtcTaxCode  :slot="caConfig.gridSlots[3]" slot-scope="{ item, editor }" :value.sync="item.taxCode" :editor="editor" list="taxCode" :required="true"/>
        <Calendar  :slot="caConfig.gridSlots[4]" slot-scope="{ item, editor }" :value.sync="item.dueDate" :editor="editor" :required="true"/>
      </ListDialog>      
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PurchaseDeliveryItemView extends Vue {
  public returnDelivery = Components.ReturnDelivery;
  public items: Common.PurchaseDeliveryItem[] = new Array(0);
  public params: Common.DeliveryItemQuery = new Common.DeliveryItemQuery(Common.SalesPurchaseFlags.Purchase);
  public importQuery = new Common.DeliveryItemImportQuery('入荷明細',Common.SalesPurchaseFlags.Purchase);
  public exportQuery = new Common.DeliveryItemExportQuery('入荷明細',this.params,Common.SalesPurchaseFlags.Purchase);
  public hasLicenseCurrency: boolean = false;
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'deliveryItemNo', text: '明細番号' },
    { value: 'bookDate', text: '仕入日' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'commodity', text: '商品' },
    { value: 'warehouse', text: '入庫倉庫' },
// <!--    { value: 'receiver', text: '納入先' },
    { value: 'deliveryNo', text: '入荷番号' },
    { value: 'deliveryDate', text: '入荷日' },
    { value: 'orderItemNo', text: '発注明細番号' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'commodityName', text: '商品名称' },
    { value: 'orderRefNo', text: '発注管理番号' },
    { value: 'deliveryRefNo', text: '入荷管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;    
  public DeliveryFlags = Common.DeliveryFlags;
  public visibleTypes = Common.visibleTypes;

  @Prop() public deliveryNo:string;
  @Prop() public deliveryItemNo:string;
  @Prop() public orderNo:string;
  @Prop() public orderItemNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop() public sku:Common.SKU;  
  @Prop() public state:Common.StockBalanceJournalStatus;      
  @Prop() public deliveryDateTo: Date;  
  @Prop() public deliveryDateFrom: Date;  
  @Prop({default:null}) public popup: Components.PopupEditor; 
  @Prop() public segment:Common.Segment;
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],24,'grid');


  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;    
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    // タブ表示の制御
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      // new Common.GridItemConfiguration('明細ID', 150),
      // new Common.GridItemConfiguration('行番号', 150),
      new Common.GridItemConfiguration('明細番号', 150),     
      new Common.GridItemConfiguration('仕入日', 150),       
      new Common.GridItemConfiguration('仕入先', 150),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('入荷数量', 150),
      new Common.GridItemConfiguration('納入区分', 150),
      new Common.GridItemConfiguration('入庫倉庫', 150),
      // new Common.GridItemConfiguration('納入先', 150),
      new Common.GridItemConfiguration('入荷番号', 150),
      // new Common.GridItemConfiguration('入荷予定日', 150),
      new Common.GridItemConfiguration('入荷日', 150),
      new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('単価', 150),
      new Common.GridItemConfiguration('税区分', 150),
      new Common.GridItemConfiguration('発注明細番号', 150),
      new Common.GridItemConfiguration('案件', 150),
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('調整数量', 150),
      new Common.GridItemConfiguration('NCV', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('棚卸対象外', 150),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('税抜金額', 150),
      new Common.GridItemConfiguration('計上金額', 150,this.hasLicenseCurrency),
      // new Common.GridItemConfiguration('備考', 150),
      new Common.GridItemConfiguration('発注管理番号', 150),
      new Common.GridItemConfiguration('入荷管理番号', 150),
      // new Common.GridItemConfiguration('受注管理番号', 150),
      // new Common.GridItemConfiguration('顧客注文番号', 150),
      // new Common.GridItemConfiguration('倉庫', 150),
      // new Common.GridItemConfiguration('ワークフロー', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,true,true));
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.deliveryNo) {
      this.params.deliveryNo = this.deliveryNo;
      this.params.state = null;
    }
    else if(this.deliveryItemNo) {
      this.params.deliveryItemNo = this.deliveryItemNo;
      this.params.state = null;
    }
    else if(this.orderNo) {
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }
    else if(this.orderItemNo) {
      this.params.orderItemNo = this.orderItemNo;
      this.params.state = null;
    }else if (!this.commodity && !this.sku && !this.state && !this.deliveryDateTo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
    if (this.segment) this.params.segment = this.segment;
    if (this.commodity)this.params.commodity = this.commodity;
    if (this.sku)this.params.sku = this.sku;
    if (this.state)this.params.state = this.state;   
    if (this.deliveryDateTo)this.params.deliveryDateTo = this.deliveryDateTo;        
    if (this.deliveryDateFrom)this.params.deliveryDateFrom = this.deliveryDateFrom;     

    this.params.isInvoiceItem = true;//delivery.counterpartをロードするため
  }
  //Vue初期化する前にCommodityロード処理を実施～Component.Hookはmain.tsに記載
  public beforeRouteEnter (to:any, from:any, next :Function) {
    //commodityCodeからcommodityをロード
    if (to.query.commodityCode){
      //thisが使えないためVue.prototypeからapiを取得
      var api = Vue.prototype.$api as Common.Api;
      api.execute(new Common.CommodityCodeQuery(to.query.commodityCode as string)).then(res =>{
        //vueインスタンスのparameterに直接セット
        next((vm:any) => vm.params.commodity = (res as Common.Commodity));      
      });
    } else {
      next();
    }
    
    this.$api.formatter.ensureListLoaded('workflow_purchaseInvoice');
    this.$api.formatter.ensureListLoaded('workflow_charge');
  }
  public async onCreate(obj: Common.PurchaseDeliveryItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_purchaseDeliveryItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  // 一覧でチェックされている出荷明細
  public checkedDeliveryItems: Array<Common.DeliveryItem>= new Array(0);
  public getCheckedDeliveryItems(){
    this.checkedDeliveryItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedDeliveryItems.push(obj);
      }
    });
  }

  // 返品ダイアログ用プロパティ
  public rdCaptions = new Array();
  public rdWidths = new Array();
  public rdSlots = new Array();
  public rdGridConfig:Common.GridConfiguration = null;

  public rdPic: string = '';
  public rdReturnDate: Date = new Date().getCalendarDate();
  public rdWorkflowId = 0;
  public rdInvoiceWorkflowId = 0;
  // ワークフロー処理用プロパティ
  public rdButtonNames: Array<string> = null;
  public rdButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  // 返品処理ダイアログを表示
  public showReturnDeliveryDialog() {
    this.getCheckedDeliveryItems();

    let componentClass = Vue.extend(this.returnDelivery);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedDeliveryItems: this.checkedDeliveryItems,
          salesPurchaseFlag: Common.SalesPurchaseFlags.Purchase,
          parentMainList: this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  //   // ダイアログ表示前バリデーション
  //   if(this.checkedDeliveryItems.length == 0){
  //     this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.quantity < 0).length > 0){
  //     this.$api.modal.show('', '返品の入荷明細が選択されています。', true, null);
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
  //     this.$api.modal.show('', '部門の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.delivery.counterpart.id != this.checkedDeliveryItems[0].delivery.counterpart.id).length > 0){
  //     this.$api.modal.show('', '仕入先の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.warehouseId != this.checkedDeliveryItems[0].warehouseId).length > 0){
  //     this.$api.modal.show('', '倉庫の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
  //     return;
  //   }

  //   // 明細の予備項目表示の可変対応

  //   this.rdGridConfig = new Common.GridConfiguration([],0,'col');
  //   this.rdGridConfig.setGridItems(
  //     new Common.GridItemConfiguration('商品', 150),
  //     new Common.GridItemConfiguration('SKU', 150),
  //     new Common.GridItemConfiguration('返品数量', 150),
  //     new Common.GridItemConfiguration('調整数量', 150),
  //   );
  //   this.rdGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));
  //   this.rdCaptions =this.rdGridConfig.gridCaptions;
  //   this.rdWidths = this.rdGridConfig.gridWidths;
  //   this.rdSlots = this.rdGridConfig.gridSlots;

  //   // プロパティの初期化
  //   this.rdPic = this.$api.auth.userId;
  //   this.rdReturnDate = new Date().getCalendarDate();
  //   this.rdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseDelivery');
  //   this.rdInvoiceWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseInvoice');
  //   this.onReturnDeliveryChangeWorkflow();

  //   // ダイアログの表示
  //   var items = this.checkedDeliveryItems.map(item => item.copy());
  //   (this.$refs.returnDeliveryDialog as Components.ListDialog).items = items;
  //   (this.$refs.returnDeliveryDialog as Components.ListDialog).showDialog();
  }

  public onReturnDeliveryChangeWorkflow(){
    this.rdButtonNames=new Array();
    this.rdButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.rdButtonNames.push("入荷保存");
    if(this.rdWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('purchaseDelivery', this.rdWorkflowId, Common.DeliveryStatus.PurchaseDeliverySaving);
      actions.forEach(action => {
        this.rdButtonNames.push(action.actionName);
        this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
  // // 返品処理の実行
  // public async submitReturnDelivery(list: Array<Common.DeliveryItem>, index:number) {
  //  // クエリの設定
  //   var query = new Common.ReturnDeliveryQuery();
  //   query.pic = this.rdPic;
  //   query.deliveryDate = this.rdReturnDate;
  //   query.deliveryItems = new Array();
  //   query.baseItems = this.checkedDeliveryItems;
  //   query.workflowId = this.rdWorkflowId;
  //   query.invoiceWorkflowId = this.rdInvoiceWorkflowId;    
  //   query.actionId = this.rdButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
  //   list.forEach(item =>{
  //     var returnItem = item.copy();
  //     returnItem.quantity *= -1;
  //     returnItem.adjustmentQuantity *= -1;
  //     query.deliveryItems.push(returnItem);
  //   });

  //   // 返品処理の実行
  //   // this.$api.execute(query)
  //   // .finally(()=>{
  //   //   this.refreshListView();
  //   // });

  //   return this.$api.execute(query,true).then(res => {
  //     //何も更新されないが..
  //      (this.$refs.mainList as Components.ListView).reload();
  //     var returnDelivery = res as Common.Delivery;
  //     this.$api.modal.show('処理結果','以下の入荷伝票が作成されました。',true,null,[new Common.ModalLink(returnDelivery.deliveryNo, String.format('/purchase/PurchaseDelivery?deliveryNo={0}',returnDelivery.deliveryNo))]);
  //     return true;
  //   }).catch(()=>{return false;});        
  // }

  // 商品変更時に商品名・予備項目を設定する
  public onChangeCommodity(item:Common.DeliveryItem){
    item.onChangeCommodity(this.tenantSettings);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.PurchaseDeliveryItem){
    this.$api.execute(new Common.DeliveryGetItemPriceQuery(item.delivery, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  // 状態から編集可能か判別する
  public isEditable(item:Common.PurchaseDeliveryItem, shouldCheckOrderItem:boolean, shouldCheckDelivering:boolean, shouldCheckTransitPost:boolean):boolean{
    if(shouldCheckTransitPost && item.delivery.isTransitPost) return false;  // 未着品計上の場合編集不可
    if(shouldCheckOrderItem && item.orderItem != null) return false;  // 紐づく発注明細がある場合編集不可
    if(item.state == Common.StockBalanceJournalStatus.PurchaseDeliverySaving) return true;
    if(shouldCheckDelivering && item.state == Common.StockBalanceJournalStatus.PurchaseDelivering) return true;
    return false;
  }
  
  // 単価・単価取得が編集可能か判別する
  public isPriceEditable(item:Common.PurchaseDeliveryItem):boolean{
    if(item.orderItem != null && (this.$api.tenantSettings as Common.TenantSettings).purchaseDeliveryPriceChangeFlag == false) return false;  // 紐づく発注明細があり、単価変更が許可されていない場合編集不可
    if(item.isPurchaseInvoicePost==false) return true;
    return false;
  }

  // 発注明細一覧へ遷移する
  public showPurchaseOrderItem(itemNo: string){
    if(itemNo) this.$router.push(String.format('/purchase/PurchaseOrderItem?orderItemNo={0}',itemNo));
  }

  // 入荷一覧へ遷移する
  public showPurchaseDelivery() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseDeliveryItem;
    if(obj.delivery) this.$router.push(String.format('/purchase/PurchaseDelivery?deliveryNo={0}', obj.delivery.deliveryNo));
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.PurchaseDeliveryItem){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseDelivery, sourceNo : item.deliveryNo, isItem: true},this.$el);
  }
  // 出荷明細一覧への遷移ボタンの非活性制御
  public disabledShowSalesDeliveryItemButton(item: Common.DeliveryItem):boolean{
    if(item.state == Common.StockBalanceJournalStatus.PurchaseDeliverySaving) return true;
    return item.deliveryFlag == Common.DeliveryFlags.Stock;
  }

  // 出荷明細一覧へ遷移する
  public showSalesDeliveryItem(){
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseDeliveryItem;
    if(obj) {
      let routeData = this.$router.resolve(String.format('/sales/SalesDeliveryItem?purchaseDeliveryItemNo={0}', obj.deliveryItemNo));
      window.open(routeData.href, '_blank');
    }
  }


  //諸掛按分処理
  //諸掛按分処理用プロパティ
  public caConfig:Common.GridConfiguration = new Common.GridConfiguration([],0,'col');
  public caPic: string = '';
  public caBookDate: Date = new Date().getCalendarDate();
  public caCurrencyCode: string='';
  public caProportionalDivision: Common.ProportionalDivisionFlags = Common.ProportionalDivisionFlags.ByQuantity;
  public caExchangeRate:number = 0;
  public caRefNo : string = '';
  public caWorkflowId: number = 0;
  public caItems : Common.PurchaseCharge[] = [];
  public caDecimal : number = 0;
  // ワークフロー処理用プロパティ
  public caButtonNames: Array<string> = null;
  public caButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  // 返品処理ダイアログを表示
  public showChargeAllocationDialog() {
    this.getCheckedDeliveryItems();

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.state != Common.StockBalanceJournalStatus.PurchaseDeliveryCompleted).length > 0){
      this.$api.modal.show('', '未処理・入荷待ちの明細は選択できません。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
      this.$api.modal.show('', '部門の異なる入荷明細を、同じ諸掛伝票にまとめることはできません。', true, null);
      return;
    }

    this.caConfig = new Common.GridConfiguration([],0,'col');
    this.caConfig.setGridItems(
      new Common.GridItemConfiguration('諸掛取引先', 150),
      new Common.GridItemConfiguration('勘定科目', 150),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('税区分', 150),
      new Common.GridItemConfiguration('支払予定日', 150),      
    );

    // プロパティの初期化
    this.caPic = this.$api.auth.userId;
    this.caBookDate = new Date().getCalendarDate();
    this.caCurrencyCode = (this.$api.tenantSettings as Common.TenantSettings).currencyCode;
    this.caExchangeRate = 1;
    this.caWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_charge');
    this.onChargeAllocationChangeWorkflow();

    // ダイアログの表示
    // var items = this.checkedDeliveryItems.map(item => item.copy());
    this.caItems = new Array();
    this.caItems.push(new Common.PurchaseCharge());
    (this.$refs.chargeAllocationDialog as Components.ListDialog).items = this.caItems;
    (this.$refs.chargeAllocationDialog as Components.ListDialog).showDialog();
  }
  public onChargeAllocationChangeWorkflow(){
    this.caButtonNames=new Array();
    this.caButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.caButtonNames.push("諸掛保存");
    if(this.caWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('charge', this.caWorkflowId, Common.ChargeStatus.ChargeSaving);
      actions.forEach(action => {
        this.caButtonNames.push(action.actionName);
        this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }

  // 取引先変更時に取引先の税区分・支払予定日を設定する
  public onChangeCounterpart(item: Common.Charge){
    item.taxCode = item.counterpart ? item.counterpart.taxCode : '';
    if(item.counterpart == null) item.dueDate = null;
    else  
    {
      var closingDate = item.counterpart.getClosingDate(this.caBookDate, this.tenantSettings);
      item.dueDate = item.counterpart.getPaymentDate(closingDate, this.tenantSettings);   
    } 
  }

  // 発生日変更時に支払予定日を設定する
  public onChangeChargeDate(){
    this.caItems.forEach(item =>{
      if(item.counterpart == null) item.dueDate = null;
      else  item.dueDate = item.counterpart.getPaymentDate(this.caBookDate, this.tenantSettings);
    });
    this.onChangeCurrency();
  }

  // 発生日・通貨が変更された場合、計上レートを取得する
  public async onChangeCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.caCurrencyCode;
    query.startDate = this.caBookDate;
    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.caExchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });

    const obj = this.$api.currencies.filter(obj => obj.value == this.caCurrencyCode); 
    if (obj.length == 0) this.caDecimal = 0;
    else this.caDecimal = Number(obj[0].text);
  }

   public async submitChargeAllocation(list: Array<Common.PurchaseCharge>, index:number){
    // 選択している入荷伝票の取得    
    if (this.caItems.length == 0){
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','諸掛を入力してください。').then(()=>{return false;});
    }    
    
    //ヘッダプロパティの設定
    this.caItems.forEach(charge =>{
      charge.currencyCode = this.caCurrencyCode;
      charge.exchangeRate = this.caExchangeRate;
      charge.proportionalDivision = this.caProportionalDivision;
      charge.workflowId = this.caWorkflowId;
      charge.chargeDate = this.caBookDate;
      charge.pic = this.caPic;
      charge.refNo = this.caRefNo;      
      charge.chargeFlag = Common.SalesPurchaseFlags.Purchase; //仕入諸掛
      charge.segment = this.checkedDeliveryItems[0].segment;
      charge.target = Common.ChargeItemTypes.Purchase;      
    });

    // クエリの設定
    var query = new Common.AddChargeAllocationQuery();
    query.charges = this.caItems; //諸掛のセット
    query.deliveryItems = this.checkedDeliveryItems; //按分対象のセット
    query.actionId = this.caButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    
    // 諸掛按分明細追加の実行
    return this.$api.execute(query,true).then(res => {
      //ダイアログ表示
      var charges = res as Common.PurchaseCharge[];
      var links = charges.map(charge=>new Common.ModalLink(charge.chargeNo,String.format('/purchase/PurchaseCharge?chargeNo={0}',charge.chargeNo)));
      //this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',true,null,links);
      this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',false,()=>this.$router.push(String.format('/purchase/PurchaseCharge?chargeNo={0}',charges[0].chargeNo)),links,'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});           
   }

  //検索予備項目
  public isSearchVisible(usedType: Common.UsedTypes){
      return usedType != Common.UsedTypes.None ;
  }       
  public get searchTabs() : string[]{
    return this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText1) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText2) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText3) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText4) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText5) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText6) ||                
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo3) ||                         
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate3) ||            
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList3) 
              ? ['検索条件','予備項目']: ['検索条件'];
  }  
}
</script>

<style lang="scss">
.purchase_delivery_item{
  .cx_itembutton {
    font-size: 14px;
    height: 28px;
    padding: 2px 7px;
    outline: 0 !important;
    box-shadow: none;
    margin: -3px 10px 10px 0px;
    // min-width:120px;
  }
  .cx_link{
    .cx_textbox_read{
      font-weight: bolder;
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        color: #3194ff !important; 
      }
    }
  }
}
</style>